import { render, staticRenderFns } from "./WaField.vue?vue&type=template&id=3775170e&"
import script from "./WaField.vue?vue&type=script&lang=js&"
export * from "./WaField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Server\\domains\\localhost\\ss\\wa-apps\\shop\\plugins\\giftcertificates\\build\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3775170e')) {
      api.createRecord('3775170e', component.options)
    } else {
      api.reload('3775170e', component.options)
    }
    module.hot.accept("./WaField.vue?vue&type=template&id=3775170e&", function () {
      api.rerender('3775170e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/components/WaField.vue"
export default component.exports